// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"481529a7","787":"9750ae9a"}[chunkId] + ".chunk.js";
};